import {Injectable} from "@angular/core";
import {TimeRange} from "./enums/time-range";
import {ErrorCodes} from "../../../../common/enums/states/error-codes";
import {EventDto} from "../../../../../../models/event/event-dto";
import {GlobalAlertService} from "../../../../../../_services/global-alert.service";
import {AlertLevel} from "../../../../../../enums/alert-level";
import {UrlHelper} from "../../../../../../helpers/url-helper";


@Injectable({
  providedIn: 'root'
})
export class TimeRepository {


  startTime!: Date;
  endTime!: Date;
  timeRange!: TimeRange;
  axisNameMap: Map<string, { name: string, index: number, time: Date }> = new Map<string, {
    name: string,
    index: number,
    time: Date
  }>()
  isYearDifferent: boolean = false

  constructor(private globalAlertService: GlobalAlertService) {

  }

  initialize(): ErrorCodes | undefined {
    let startTime = UrlHelper.QueryParams.startTime
    let endTime = UrlHelper.QueryParams.endTime

    let valid = this.isValid(startTime, endTime)
    if (valid !== undefined) {
      return valid
    }

    this.startTime = new Date(parseInt(startTime) * 1000)
    this.endTime = new Date(parseInt(endTime) * 1000)
    this.timeRange = TimeRepository.findTimeRange(this.startTime, this.endTime);
    return undefined
  }

  private isValid(startTime: string, endTime: string): ErrorCodes | undefined {

    if (startTime === "" || startTime === undefined || endTime === "" || endTime === undefined) {
      this.globalAlertService.createAndShow("Fehler", "Kein Datum angegeben. Bitte geben Sie ein Datum an.", AlertLevel.error)
      return ErrorCodes.noDate
    }
    return undefined
  }


  static findTimeRange(startTime: Date, endTime: Date): TimeRange {
    if (startTime.getMonth() === endTime.getMonth() && startTime.getFullYear() === endTime.getFullYear()) {
      return TimeRange.EVENT;
    }

    // Todo implement this
    return TimeRange.MONTH
  }

  createGroupAxisNameMap(events: EventDto[]) {

    if (this.timeRange === TimeRange.EVENT) {
      this.axisNameMap = this.createEventAxisNameMap(events)
      return
    }
    this.axisNameMap = this.createMonthAxisNameMap()
  }

  private createEventAxisNameMap(events: EventDto[]) {
    let axisNameMap = new Map<string, { name: string, index: number, time: Date }>()
    events.sort((a, b) => +a.start - +b.start)
    let counter = 0
    for (let event of events) {
      axisNameMap.set(event.id, {name: event.name, index: counter, time: event.start})
      counter += 1
    }

    return axisNameMap
  }

  public createMonthAxisNameMap() {
    let axisNameMap = new Map<string, { name: string, index: number, time: Date }>()
    let start = new Date(this.startTime)
    let end = new Date(this.endTime)
    start.setDate(10)
    end.setDate(11)
    this.isYearDifferent = start.getFullYear() !== end.getFullYear()
    let counter = 0
    while (start <= end) {
      axisNameMap.set(this.toDateString(start), {name: this.toDateString(start), index: counter, time: start})
      start.setMonth(start.getMonth() + 1)
      counter += 1
    }
    // Todo sort map by key

    return axisNameMap
  }

  getMonthNameMap() {
    if (this.timeRange === TimeRange.EVENT) {
      return this.createMonthAxisNameMap()
    }
    return this.axisNameMap
  }


  toKey(date: Date, eventId: string): string {
    if (this.timeRange === TimeRange.EVENT) {
      return eventId // this.axisNameMap.get(eventId)?.index ?? -1
    }
    return this.toDateString(date) // this.axisNameMap.get(this.toDateString(date))?.index ?? -1
  }


  toInterval(key: string) {
    return this.axisNameMap.get(key)?.index ?? -1
  }

  getAxisNameMapTimeInterval(key: string) {
    if (this.timeRange === TimeRange.EVENT) {
      return this.toDateString(this.axisNameMap.get(key)?.time!)
    }
    return key
  }


  /**
   * Converts a date to a string. If the year is different, the last two digits of the year is included in the string.
   * @param date
   * @param isYearDifferent
   */
  toDateString(date: Date): string {
    let options: Intl.DateTimeFormatOptions
    if (this.isYearDifferent) {
      options = {month: 'long', year: '2-digit'};
    } else {
      options = {month: 'long'};
    }
    return date.toLocaleDateString('default', options)
  }


  startAsISOString(): string {
    return this.startTime.toISOString()
  }

  endAsISOString(): string {
    return this.endTime.toISOString()
  }


}
